import * as generalApi from '../../general/api';

export function fetchFilters(params) {
  return generalApi.getFilters({ cloudType: 'vdc', ...params });
}
